import React, { useEffect, useState } from "react";
import { getPackageDetailData } from "../../../commons/api/GetPackageDetailsResults.js";
import Loader from "@amzn/meridian/loader";
import ReportView from "./ReportView.js";
import { getContainerDetail } from "./safetyReport/GetContainerDetail.js";
import { getCompleteContainerHistoryForUser } from "./safetyReport/GetContainerHistory.js";
import Heading from "@amzn/meridian/heading";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";

import TimeSelect, { timeRange } from "@amzn/meridian/time-select";
import Text from "@amzn/meridian/text";
import {
  CONTAINER_LABEL_CART,
  CONTAINER_MOVE_STATE,
  CONTAINER_TYPE_BAG,
  PACKAGE_EVENT_STATE_INDUCTED,
  PACKAGE_EVENT_STATE_PICKED,
  PACKAGE_EVENT_STATE_STAGED,
  PACKAGE_EVENT_STATE_STOWED,
  PACKAGE_TYPE_OV,
  CONTAINER_LABEL,
  getUniqueElementsFromList,
  KG_TO_POUND,
  HEAVY_BAG,
  HEAVY_PACKAGE,
  convertWeightToKilograms,
  delay,
  epochDiffInDays,
  INITIAL_MESSAGE,
  PACKAGE_DETAIL_PROCESSING,
  CONTAINER_DETAIL_PROCESSING,
  adjustTimeBasedOnResetClock,
  PROCESS_NAME,
  METRIC_NAME_REGNERATE_REPORT,
  METRIC_NAME_GNERATE_REPORT,
  StringUtil,
  getDateFromEpoch,
  calculateReportUpdateEpoch,
  ERROR_MESSAGE_START_TIME_SHOULD_BE_LESS,
  CART_DETAIL_PROCESSING,
} from "./safetyReport/Util.js";

import {
  calculateOVPickedReportMetadata,
  calculateOVStagedReportMetadata,
  calculateOVStowReportMetadata,
} from "./safetyReport/OVReport.js";
import {
  ReportMetadata,
  LastPackageReportMetadata,
} from "./safetyReport/ReportViewSchema.js";
import {
  getPickReportMetadata,
  generateStageReportMetadata,
} from "./safetyReport/ContainerReport.js";
import { getCompletePackageHistoryForAssociate } from "./safetyReport/GetPackageHistory.js";
import { fetchBatchPackageSummary } from "./safetyReport/BatchPackageSummary.js";
import { ErrorView } from "./safetyReport/ErrorView.js";
import { logOperationalMetric } from "../../../util/CommonUtils.js";
import Column from "@amzn/meridian/column/column.js";
const IncidentReportView = ({ associateLoginId, startTime, endTime }) => {
  const [loader, setLoader] = useState(true);
  const [stowReport, setStowReport] = useState(null);
  const [inductReport, setInductedReport] = useState(null);
  const [stowOVReport, setStowOVReport] = useState(null);
  const [pickOVReport, setPickOVReport] = useState(null);
  const [stagedOVReport, setStagedOVReport] = useState(null);
  const [pickReport, setPickReport] = useState(null);
  const [stageReport, setStageReport] = useState(null);
  const [tierData, setPickTierData] = useState(null);
  const [lastPackageReport, setLastPackageReport] = useState(null);
  const [error, setError] = useState(false);
  const [loaderPercent, setLoaderPercent] = useState(0);
  const [displayMessage, setDisplayMessage] = useState(
    StringUtil.format(INITIAL_MESSAGE, 2)
  );
  const [reportStartTime, setReportStartTime] = useState("17:00:00");
  const [reportEndTime, setReportEndTime] = useState("17:00:00");

  const [reportStartEpoch, setReportStartEpoch] = useState(startTime);
  const [reportEndEpoch, setReportEndEpoch] = useState(endTime);
  const [startTimePickerErrorMessage, setStartTimePickerErrorMessage] =
    useState(null);
  const [endTimePickerErrorMessage, setEndTimePickerErrorMessage] =
    useState(null);

  useEffect(() => {
    const opsClockStartTime = adjustTimeBasedOnResetClock(startTime);
    const opsClockEndTime = adjustTimeBasedOnResetClock(endTime);
    setReportStartEpoch(opsClockStartTime);
    setReportEndEpoch(opsClockEndTime);
    const metricStartTime = Date.now();
    generateReport(
      associateLoginId,
      opsClockStartTime,
      opsClockEndTime,
      opsClockStartTime,
      opsClockEndTime
    )
      .then(() => {
        logOperationalMetric(
          metricStartTime,
          PROCESS_NAME,
          METRIC_NAME_GNERATE_REPORT,
          true
        );
      })
      .catch(() => {
        logOperationalMetric(
          metricStartTime,
          PROCESS_NAME,
          METRIC_NAME_REGNERATE_REPORT,
          false
        );
      });
  }, []);

  const generateReport = async (
    loginId,
    opsClockStartTime,
    opsClockEndTime,
    reportStartTime,
    reportEndTime
  ) => {
    if (
      epochDiffInDays(startTime, endTime) > 1 ||
      epochDiffInDays(opsClockStartTime, opsClockEndTime) > 1
    ) {
      setError(true);
      return;
    }
    if (reportStartTime >= reportEndTime) {
      return;
    }
    setLoader(true);
    await processPackageResult(loginId, reportStartTime, reportEndTime);
    setLoaderPercent(10);

    await processContainerMoveResult(
      loginId,
      opsClockStartTime,
      opsClockEndTime,
      reportStartTime,
      reportEndTime
    );
    setLoader(false);
  };
  const processPackageResult = async (associateLoginId, startTime, endTime) => {
    const allPackageHistory = await getCompletePackageHistoryForAssociate(
      associateLoginId,
      startTime,
      endTime
    );
    await fetchPackageHistoryReport(allPackageHistory);

    console.log(
      "Report Generation Successful for Package Data",
      allPackageHistory
    );
  };

  const processContainerMoveResult = async (
    associateLoginId,
    opsClockStartTime,
    opsClockEndTime,
    startTime,
    endTime
  ) => {
    const allContainer = await getCompleteContainerHistoryForUser(
      associateLoginId,
      startTime,
      endTime
    );
    console.log("Report Fetched for Container History {}", allContainer);
    await processContainerData(
      allContainer,
      opsClockStartTime,
      opsClockEndTime
    );
  };

  const processContainerData = async (
    containerData,
    opsClockStartTime,
    opsClockEndTime
  ) => {
    let movedContainer = containerData.filter(
      (container) =>
        container.containerState != null &&
        container.containerLabel != null &&
        container.containerState === CONTAINER_MOVE_STATE &&
        !container.containerLabel.startsWith(CONTAINER_LABEL_CART)
    );
    console.log("Total Containers Moved {}", movedContainer);

    let allCarts = containerData.filter(
      (container) =>
        container.containerLabel != null &&
        container.containerLabel.startsWith(CONTAINER_LABEL_CART)
    );

    console.log("Total Carts Moved {}", allCarts);

    let pickedBags = movedContainer.filter(
      (container) =>
        container.scanLocation != null &&
        container.scanLocation.startsWith(CONTAINER_LABEL_CART)
    );
    let stagedBags = movedContainer.filter(
      (containerData) =>
        containerData.scanLocation != null &&
        containerData.scanLocation.startsWith(CONTAINER_LABEL_CART)
    );

    const uniqueContainerData = getUniqueElementsFromList(
      movedContainer,
      CONTAINER_LABEL
    );

    setDisplayMessage(
      StringUtil.format(CONTAINER_DETAIL_PROCESSING, uniqueContainerData.length)
    );
    let bagReportMap = await generateBagReportMap(
      uniqueContainerData,
      opsClockStartTime,
      opsClockEndTime
    );
    console.log("Bag Report Map Generation completed {}", bagReportMap);

    const result = calculateContainerResult(bagReportMap, pickedBags);
    const tierLevelData = calculateTierData(bagReportMap, pickedBags);
    setPickTierData(tierLevelData);
    setPickReport(getPickReportMetadata(result));
    console.log("Container Result Generated {}", result);
    setDisplayMessage(
      StringUtil.format(CART_DETAIL_PROCESSING, Math.ceil(allCarts.length / 2))
    );
    setStageReport(
      await generateStageReportMetadata(
        allCarts,
        bagReportMap,
        stagedBags,
        opsClockStartTime,
        opsClockEndTime
      )
    );
  };

  const calculateTierData = (bagReportMap, pickedBags) => {
    const tiers = ["Tier1", "Tier2", "Tier3", "Tier4"]; // Example tier array
    const categorizedBags = [];
    tiers.forEach((tier) => {
      const tierBags = pickedBags.filter((bag) => {
        const pickLocation = bagReportMap[bag.containerLabel].bagPickLocation;
        if (pickLocation) {
          const parts = pickLocation.split(".");
          const locationPart = parts[parts.length - 1].trim();
          return locationPart.charAt(0) === tier.replace("Tier", "");
        }
        return false;
      });

      let result = tierBags.reduce(
        (acc, curr) => ({
          maxBagWt: Math.max(
            acc.maxBagWt,
            bagReportMap[curr.containerLabel].totalWeight
          ),
          totalWt: acc.totalWt + bagReportMap[curr.containerLabel].totalWeight,
          bagCount: acc.bagCount + 1,
        }),
        { maxBagWt: 0, totalWt: 0, bagCount: 0 }
      );

      categorizedBags.push({ tier, result });
    });

    return categorizedBags;
  };

  const calculateContainerResult = (bagReportMap, pickedBags) => {
    let result = pickedBags.reduce(
      (acc, curr) => ({
        maxBagWt: Math.max(
          acc.maxBagWt,
          bagReportMap[curr.containerLabel].totalWeight
        ),
        maxPackageWt: Math.max(
          acc.maxPackageWt,
          bagReportMap[curr.containerLabel].maxPackageWt
        ),
        totalWt: acc.totalWt + bagReportMap[curr.containerLabel].totalWeight,
        packageCount:
          acc.packageCount + bagReportMap[curr.containerLabel].totalPackage,
        bagCount: acc.bagCount + 1,
        heavyCount:
          acc.heavyCount +
          (bagReportMap[curr.containerLabel].totalWeight * KG_TO_POUND >
          HEAVY_BAG
            ? 1
            : 0),
      }),
      {
        maxBagWt: 0,
        maxPackageWt: 0,
        totalWt: 0,
        packageCount: 0,
        bagCount: 0,
        heavyCount: 0,
      }
    );
    return result;
  };

  const fetchContainerDetail = async (
    container,
    opsClockStartTime,
    opsClockEndTime
  ) => {
    return await getContainerDetail(
      container.stationCode,
      container.containerLabel,
      opsClockStartTime,
      opsClockEndTime,
      container.eventTime,
      container.routeCode,
      CONTAINER_TYPE_BAG
    );
  };

  const generateBagReportMap = async (
    movedContainer,
    opsClockStartTime,
    opsClockEndTime
  ) => {
    //TODO
    const incrementFactorForLoader =
      movedContainer.length === 0 ? 70 : 70 / movedContainer.length;
    let bagReportMap = {};
    for (const container of movedContainer) {
      const bagReport = await fetchContainerDetail(
        container,
        opsClockStartTime,
        opsClockEndTime
      );

      bagReportMap[bagReport.bagId] = bagReport;
      setLoaderPercent(
        (loaderPercent) => loaderPercent + Math.ceil(incrementFactorForLoader)
      );
      await delay(100);
    }
    return bagReportMap;
  };

  const fetchPackageHistoryReport = async (workingPackageList) => {
    console.log(
      "Package History Fetched SUcessfully for the user {} ",
      workingPackageList
    );
    setLoaderPercent(5);

    let lastPackageDetails =
      workingPackageList.length > 0 ? workingPackageList[0] : null;

    let totalStowedPackages = workingPackageList.filter(
      (pp) =>
        pp.packageEventState &&
        pp.packageEventState.includes(PACKAGE_EVENT_STATE_STOWED) &&
        !pp.scanLocation.startsWith(PACKAGE_TYPE_OV)
    );

    let totalInductedPackages = workingPackageList.filter(
      (pp) =>
        pp.packageEventState &&
        pp.packageEventState.includes(PACKAGE_EVENT_STATE_INDUCTED)
    );

    let totalOVStowedPackages = workingPackageList.filter(
      (pp) =>
        pp.packageEventState &&
        pp.packageEventState.includes(PACKAGE_EVENT_STATE_STOWED) &&
        pp.scanLocation.startsWith(PACKAGE_TYPE_OV)
    );

    let totalOVPickedPackages = workingPackageList.filter(
      (pp) =>
        pp.packageEventState &&
        pp.packageEventState.includes(PACKAGE_EVENT_STATE_PICKED)
    );
    let totalOVStagedPackages = workingPackageList.filter(
      (pp) =>
        pp.packageEventState &&
        pp.packageEventState.includes(PACKAGE_EVENT_STATE_STAGED)
    );

    setDisplayMessage(
      StringUtil.format(
        PACKAGE_DETAIL_PROCESSING,
        totalInductedPackages.length,
        totalStowedPackages.length,
        totalOVPickedPackages.length,
        totalOVStagedPackages.length
      )
    );
    setLastPackageReport(await calculateLastPackageReport(lastPackageDetails));

    setInductedReport(
      await calculateInductedReportMetadata(totalInductedPackages)
    );

    setStowReport(await calculateStowReportMetadata(totalStowedPackages));

    setStowOVReport(await calculateOVStowReportMetadata(totalOVStowedPackages));

    setPickOVReport(
      await calculateOVPickedReportMetadata(totalOVPickedPackages)
    );
    setStagedOVReport(
      await calculateOVStagedReportMetadata(totalOVStagedPackages)
    );
  };

  const calculateLastPackageReport = async (lastPackageDetail) => {
    if (lastPackageDetail === null) {
      return null;
    }

    let data = await getPackageDetailData(lastPackageDetail.trackingId);

    if (data === null) {
      return null;
    }
    return new LastPackageReportMetadata(
      data.packageDetail.packageData.packageDimensions.packageWeight,
      data.packageDetail.packageData.packageDimensions.packageLength,
      data.packageDetail.packageData.packageDimensions.packageWidth,
      data.packageDetail.packageData.packageDimensions.packageHeight,
      data.packageDetail.packageData.lastUpdatedTime,
      data.packageDetail.packageData.trackingId
    );
  };

  const calculateInductedReportMetadata = async (totalInductedPackages) => {
    if (totalInductedPackages.length === 0) {
      return new ReportMetadata(0, 0, 0, 0);
    }
    const inductedTrackingIds = totalInductedPackages.map(
      (inductedPackage) => inductedPackage.trackingId
    );

    let inductedPackageDetails = await fetchBatchPackageSummary(
      inductedTrackingIds
    );

    let result = inductedPackageDetails.reduce(
      (acc, curr) => {
        const currPackageWeight = convertWeightToKilograms(
          curr.packageWeight.value,
          curr.packageWeight.unit
        );
        return {
          max: Math.max(acc.max, currPackageWeight),
          sum: acc.sum + currPackageWeight,
          count: acc.count + 1,
        };
      },
      { max: -Infinity, sum: 0, count: 0 }
    );
    return new ReportMetadata(
      result.count,
      result.max,
      result.sum / result.count,
      result.sum
    );
  };

  const calculateStowReportMetadata = async (totalStowedPackages) => {
    if (totalStowedPackages.length === 0) {
      return new ReportMetadata(0, 0, 0, 0);
    }
    const stowTrackingIds = totalStowedPackages.map(
      (stowedPackage) => stowedPackage.trackingId
    );

    let stowPackageDetails = await fetchBatchPackageSummary(stowTrackingIds);

    let result = stowPackageDetails.reduce(
      (acc, curr) => {
        const currPackageWeight = convertWeightToKilograms(
          curr.packageWeight.value,
          curr.packageWeight.unit
        );
        return {
          max: Math.max(acc.max, currPackageWeight),
          sum: acc.sum + currPackageWeight,
          count: acc.count + 1,
          heavyCount:
            acc.heavyCount +
            (currPackageWeight * KG_TO_POUND > HEAVY_PACKAGE ? 1 : 0),
        };
      },
      { max: -Infinity, sum: 0, count: 0, heavyCount: 0 }
    );
    return new ReportMetadata(
      result.count,
      result.max,
      result.sum / result.count,
      result.sum,
      result.heavyCount
    );
  };

  const updateEndTimeFromSelector = (time) => {
    setReportEndTime(time);
    const { newStartEpoch, newEndEpoch } = calculateReportUpdateEpoch(
      startTime,
      reportStartTime,
      time
    );

    setReportStartEpoch(newStartEpoch);
    setReportEndEpoch(newEndEpoch);

    setEndTimePickerErrorMessage("");
    setStartTimePickerErrorMessage("");

    if (newStartEpoch > newEndEpoch) {
      setEndTimePickerErrorMessage(ERROR_MESSAGE_START_TIME_SHOULD_BE_LESS);
    }
  };

  const updateStartTimeFromSelector = (time) => {
    setReportStartTime(time);
    const { newStartEpoch, newEndEpoch } = calculateReportUpdateEpoch(
      startTime,
      time,
      reportEndTime
    );

    setReportStartEpoch(newStartEpoch);
    setReportEndEpoch(newEndEpoch);

    setEndTimePickerErrorMessage("");
    setStartTimePickerErrorMessage("");
    if (newStartEpoch > newEndEpoch) {
      setStartTimePickerErrorMessage(ERROR_MESSAGE_START_TIME_SHOULD_BE_LESS);
    }
  };

  const regenerateReport = async () => {
    if (startTime === reportStartEpoch && endTime === reportEndEpoch) {
      return;
    }
    const metricStartTime = Date.now();
    const opsClockStartTime = adjustTimeBasedOnResetClock(startTime);
    const opsClockEndTime = adjustTimeBasedOnResetClock(endTime);
    await generateReport(
      associateLoginId,
      opsClockStartTime,
      opsClockEndTime,
      reportStartEpoch,
      reportEndEpoch
    )
      .then(() => {
        logOperationalMetric(
          metricStartTime,
          PROCESS_NAME,
          METRIC_NAME_REGNERATE_REPORT,
          true
        );
      })
      .catch(() => {
        logOperationalMetric(
          metricStartTime,
          PROCESS_NAME,
          METRIC_NAME_REGNERATE_REPORT,
          false
        );
      });
  };
  return (
    <React.Fragment>
      <Text>
        Report is generated from 5PM(Selected day - 1) to 5PM (Selected day) to
        match with Shift clock
      </Text>
      {error ? <ErrorView /> : null}
      {loader ? (
        <React.Fragment>
          <Loader type="linear" percentage={loaderPercent} />
          <br></br>
          <Heading level={3}>{displayMessage}</Heading>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Row>
            <Column>
              <Column>
                <TimeSelect
                  placeholder="Report Start"
                  onChange={(time) => {
                    updateStartTimeFromSelector(time);
                  }}
                  format={{ hour: "2-digit", minute: "2-digit" }}
                  options={timeRange({
                    start: "00:00",
                    end: "23:59",
                    step: 900, // 15 seconds
                  })}
                  value={reportStartTime}
                  errorMessage={startTimePickerErrorMessage}
                  helperText="Report Start Time"
                  size="small"
                />
              </Column>
              <Column>
                <strong>{getDateFromEpoch(reportStartEpoch)}</strong>
              </Column>
            </Column>
            <Column>
              <Column>
                <TimeSelect
                  placeholder="Report End"
                  onChange={(time) => {
                    updateEndTimeFromSelector(time);
                  }}
                  format={{ hour: "2-digit", minute: "2-digit" }}
                  options={timeRange({
                    start: "00:00",
                    end: "23:59",
                    step: 900, // 15 seconds
                  })}
                  value={reportEndTime}
                  size="small"
                  errorMessage={endTimePickerErrorMessage}
                  helperText="Report End Time"
                />
              </Column>
              <Column>
                <strong>{getDateFromEpoch(reportEndEpoch)} </strong>
              </Column>
            </Column>
            <Column>
              <Button onClick={regenerateReport} type="primary" size="medium">
                Generate Partial Report
              </Button>
              <Column></Column>
            </Column>
          </Row>
          <ReportView
            stowReport={stowReport}
            inductReport={inductReport}
            stowOVReport={stowOVReport}
            pickedOVReport={pickOVReport}
            stagedOVReport={stagedOVReport}
            pickReport={pickReport}
            stageReport={stageReport}
            tierData={tierData}
            lastPackageReport={lastPackageReport}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default IncidentReportView;



// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/IncidentReportView.jsx